import script from "./AdminFaqPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFaqPanel.vue?vue&type=script&setup=true&lang=js"

import "./AdminFaqPanel.vue?vue&type=style&index=0&id=e8005dcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8005dcc"]])

export default __exports__